var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.75c0 3.883-3.145 7-7 7-3.883 0-7-3.117-7-7 0-3.855 3.117-7 7-7 3.855 0 7 3.145 7 7zM3.352 3.758A6.037 6.037 0 001.875 7.75 6.115 6.115 0 008 13.875a6.037 6.037 0 003.992-1.477l-8.64-8.64zM14.125 7.75c0-3.363-2.762-6.125-6.125-6.125a6.078 6.078 0 00-4.02 1.504l8.641 8.64a6.078 6.078 0 001.504-4.019z",
    fill: "#DD4267"
  })));
}
export default SvgBan;